export enum RowAnimation {
  SHOW_ROW = 'show-row',
  HIDE_ROW = 'hide-row',
  REMOVE_LEFT_BORDER = 'remove-left-border',
}
